import banappConfig from '../../../../../banapp.config';

export type FullStoryConfig = {
  orgId: string;
  enabled: boolean;
  consentId: string;
};

/**
 * Gets FullStory configuration from banapp.config
 */
//TODO: Move this to the config service
export function getFullStoryConfig(): FullStoryConfig {
  const config = banappConfig();
  return config.fullstory;
}
export function getRegistrationUrl(): string {
  return `https://login.haufe-lexware.com/register/register.jsp?service=akademie`;
}
